import ApiService from '../services/ApiService'

export const login = (body) => new ApiService('POST', '/login', body)
export const refreshToken = () => new ApiService('POST', '/refresh-token', {}, { withAuth: true })
export const register = (body) => new ApiService('POST', '/register', body)
export const quickRegister = (body) => new ApiService('POST', '/quick-register', body)
export const registerCompany = (body) => new ApiService('POST', '/register-company', body)

export const ghostLogin = (body) => new ApiService('POST', '/ghost', body, { withAuth: true })
